import React, { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import HerissonLogo from "@/components/HerissonLogo";
import { useAuth } from "@/lib/AuthContext";
import { toast } from "sonner";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const loc = useLocation();
  const next = new URLSearchParams(loc.search).get("next") || "/account";
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email.trim().toLowerCase(), password);
      toast.success("Connecté 🎉");
      nav(next);
    } catch (e) { toast.error(e?.response?.data?.detail || "Échec de connexion"); }
    finally { setLoading(false); }
  };

  return (
    <div className="max-w-md mx-auto px-4 py-16">
      <div className="card-hsg p-6">
        <div className="flex justify-center mb-2"><HerissonLogo size="md" /></div>
        <p className="text-center text-neutral-400 mb-6">Connexion à votre compte</p>
        <form onSubmit={submit} className="space-y-4">
          <label className="block">
            <span className="text-xs uppercase tracking-widest text-neutral-500">Email</span>
            <input required type="email" value={email} onChange={(e) => setEmail(e.target.value)} className="mt-1 w-full bg-neutral-900 border border-neutral-700 rounded-lg px-3 py-2" data-testid="login-email" />
          </label>
          <label className="block">
            <span className="text-xs uppercase tracking-widest text-neutral-500">Mot de passe</span>
            <input required type="password" value={password} onChange={(e) => setPassword(e.target.value)} className="mt-1 w-full bg-neutral-900 border border-neutral-700 rounded-lg px-3 py-2" data-testid="login-password" />
          </label>
          <button disabled={loading} type="submit" className="brand-gradient-btn w-full py-3 rounded-xl" data-testid="login-submit">
            {loading ? "…" : "Se connecter"}
          </button>
        </form>
        <div className="text-center mt-4 text-sm text-neutral-400">
          Pas encore de compte ? <Link to="/register" className="text-[#5BC5F2]">Créer un compte</Link>
        </div>
      </div>
    </div>
  );
}
